import { Suspense, memo } from 'react';

import { Loader } from '../loader/Loader';
import { SuspenseWrapperProps } from './SuspenseWrapper.types';

export const SuspenseWrapper = memo(({ fallback = <Loader size="large" />, children }: SuspenseWrapperProps) => (
  <Suspense fallback={fallback}>{children}</Suspense>
));
